"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Preview/components/Informations.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    QuillEditor_template = require("../../../../components/QuillEditor/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    QuillEditor_tag = marko_loadTag(QuillEditor_template),
    Card_Accordion_template = require("../../../components/Card-Accordion/index.marko"),
    Card_Accordion_tag = marko_loadTag(Card_Accordion_template),
    ContentTable_template = require("./ContentTable.marko"),
    ContentTable_tag = marko_loadTag(ContentTable_template),
    ProgramTable_template = require("./ProgramTable.marko"),
    ProgramTable_tag = marko_loadTag(ProgramTable_template),
    Switch_template = require("../../../../components/Switch/index.marko"),
    Switch_tag = marko_loadTag(Switch_template),
    marko_attrs0 = {
        "class": "accordion collapse-icon accordion-icon-rotate",
        id: "details",
        "data-toggle-hover": "true"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  Card_Accordion_tag({
      target: "about-content",
      title: input.type + " About",
      icon: "bx-info-circle",
      contentClass: "show",
      renderBody: function(out) {
        QuillEditor_tag({
            value: input.about,
            readOnly: true,
            height: "100%"
          }, out, __component, "2");
      }
    }, out, __component, "1");

  Card_Accordion_tag({
      target: "outline-content",
      title: input.type + " Outline",
      icon: "bx-list-ul",
      contentClass: "p-1",
      renderBody: function(out) {
        Switch_tag({
            by: input.type,
            case: [
                {
                    is: "course",
                    renderBody: function(out) {
                      ContentTable_tag({
                          list: input.outlines
                        }, out, __component, "6");
                    }
                  },
                {
                    is: "program",
                    renderBody: function(out) {
                      ProgramTable_tag({
                          list: input.outlines
                        }, out, __component, "8");
                    }
                  }
              ]
          }, out, __component, "4");
      }
    }, out, __component, "3");

  Card_Accordion_tag({
      target: "objective-content",
      title: input.type + " Objectives",
      icon: "bx-list-check",
      contentClass: "p-1",
      renderBody: function(out) {
        QuillEditor_tag({
            value: input.objectives,
            readOnly: true,
            height: "100%"
          }, out, __component, "10");
      }
    }, out, __component, "9");

  Card_Accordion_tag({
      target: "policy-content",
      title: input.type + " Policy",
      icon: "bx-copyright",
      contentClass: "p-1",
      renderBody: function(out) {
        QuillEditor_tag({
            value: input.policy,
            readOnly: true,
            height: "100%"
          }, out, __component, "12");
      }
    }, out, __component, "11");

  Card_Accordion_tag({
      target: "reading-content",
      title: input.type + " Reading",
      icon: "bx-book-content",
      contentClass: "p-1",
      renderBody: function(out) {
        QuillEditor_tag({
            value: input.readings,
            readOnly: true,
            height: "100%"
          }, out, __component, "14");
      }
    }, out, __component, "13");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
